var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpdeskSidebarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "dynamic project identifier"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 8,
    fill: "url(#paint0_linear_3212_1286)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "person_raised_hand"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3212_1286",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 6,
    y: 6,
    width: 12,
    height: 12,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3212_1286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_raised_hand_2",
    d: "M6.6875 17.875V16.7875H17.325V17.875H6.6875ZM7.675 16.0375V13.175C7.3 12.3417 7.04583 11.6889 6.9125 11.2168C6.77917 10.7446 6.7125 10.2849 6.7125 9.83752C6.7125 9.41252 6.76875 8.90836 6.88125 8.32502C6.99375 7.74169 7.17083 7.17919 7.4125 6.63752C7.5125 6.42919 7.64442 6.26461 7.80825 6.14377C7.972 6.02294 8.15675 5.96252 8.3625 5.96252C8.59242 5.96252 8.77071 6.04586 8.89737 6.21252C9.02412 6.37919 9.09971 6.62532 9.12413 6.9509L9.225 8.80002C9.25833 9.15002 9.35417 9.47711 9.5125 9.78127C9.67083 10.0854 9.875 10.3479 10.125 10.5688C10.375 10.7896 10.661 10.9625 10.9829 11.0875C11.3048 11.2125 11.6438 11.275 12 11.275C12.7456 11.275 13.3661 11.3168 13.8616 11.4003C14.3572 11.4838 14.7658 11.6129 15.0875 11.7875C15.5042 12.0042 15.8125 12.2938 16.0125 12.6563C16.2125 13.0188 16.3125 13.4417 16.3125 13.925V16.0375H7.675ZM8.76325 14.95H15.225V13.925C15.225 13.6336 15.1542 13.3816 15.0125 13.169C14.8708 12.9564 14.65 12.775 14.35 12.625C14.1667 12.5334 13.8958 12.4667 13.5375 12.425C13.1792 12.3834 12.6667 12.3625 12 12.3625C11.5583 12.3625 11.1354 12.2959 10.7313 12.1625C10.3271 12.0292 9.95833 11.8396 9.625 11.5938C9.29167 11.3479 9.00833 11.0521 8.775 10.7063C8.54167 10.3604 8.375 9.97502 8.275 9.55002V7.92502C8.14167 8.10836 8.02917 8.41044 7.9375 8.83127C7.84583 9.25211 7.8 9.58752 7.8 9.83752C7.8 10.2821 7.87917 10.7204 8.0375 11.1523C8.19583 11.5841 8.43775 12.1584 8.76325 12.875V14.95ZM12.0031 10.5875C11.401 10.5875 10.8896 10.3771 10.4688 9.95627C10.0479 9.53544 9.8375 9.02294 9.8375 8.41877C9.8375 7.81461 10.0481 7.30211 10.4693 6.88127C10.8905 6.46044 11.4009 6.25002 12.0005 6.25002C12.6002 6.25002 13.1125 6.46057 13.5375 6.88165C13.9625 7.30273 14.175 7.81302 14.175 8.41252C14.175 9.02086 13.9635 9.53544 13.5406 9.95627C13.1177 10.3771 12.6052 10.5875 12.0031 10.5875ZM12 9.50002C12.2965 9.50002 12.5519 9.3929 12.7661 9.17865C12.9804 8.9644 13.0875 8.71111 13.0875 8.41877C13.0875 8.12644 12.9804 7.87315 12.7661 7.6589C12.5519 7.44465 12.2965 7.33752 12 7.33752C11.7035 7.33752 11.4502 7.44465 11.2401 7.6589C11.03 7.87315 10.925 8.12644 10.925 8.41877C10.925 8.71111 11.03 8.9644 11.2401 9.17865C11.4502 9.3929 11.7035 9.50002 12 9.50002ZM10.0875 16.0375V15.3C10.0875 14.7084 10.293 14.2063 10.7039 13.7938C11.1149 13.3813 11.6178 13.175 12.2125 13.175H13.575V14.075H12.2125C11.8675 14.075 11.5771 14.1934 11.3412 14.4302C11.1054 14.6669 10.9875 14.9569 10.9875 15.3V16.0375H10.0875Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3212_1286",
    x1: 0,
    y1: 0,
    x2: 24,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF86FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6F36F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpdeskSidebarIcon);
export default __webpack_public_path__ + "static/media/helpdesk_sidebar_icon.04d16274744e304570426c4793f05820.svg";
export { ForwardRef as ReactComponent };